import { render, staticRenderFns } from "./liveEntry.vue?vue&type=template&id=bf70cb62&"
import script from "./liveEntry.vue?vue&type=script&lang=js&"
export * from "./liveEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports